import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import type { FormFieldMessage } from '../../../types';

@Component({
  selector: 'om-form-field',
  imports: [CommonModule, TranslateModule],
  templateUrl: './form-field.html',
  styleUrl: './form-field.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormField implements OnInit {
  label = input<string>('');
  control = input.required<FormControl>();
  errorMessages = input<FormFieldMessage>({});
  inputId = input<string>('');
  submitted = input<boolean>(false);

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    if (this.control()) {
      this.control().valueChanges.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => {
        this.cdr.markForCheck();
      });
      this.control().statusChanges.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => {
        this.cdr.markForCheck();
      });
    }
  }

  getFirstErrorKey(): string | null {
    const errors = this.control().errors;
    if (errors) {
      return Object.keys(errors)[0];
    }
    return null;
  }
}
